import { graphql } from "../gql";

export default graphql(`
  query getGameLeaders($input: OddsMarketTypesInput!) {
    event(input: $input) {
      status
      awayTeam {
        abbreviation
        shortName
        logoSVG
        teamJerseySVG
        primaryColor
        secondaryColor
        gameLeaders {
          passing {
            name
            position
            completions
            attempts
            yards
            touchdowns
          }
          rushing {
            name
            position
            carries
            yards
            touchdowns
          }
          receiving {
            name
            position
            receptions
            targets
            yards
            touchdowns
          }
        }
      }
      homeTeam {
        abbreviation
        shortName
        logoSVG
        teamJerseySVG
        primaryColor
        secondaryColor
        gameLeaders {
          passing {
            name
            position
            completions
            attempts
            yards
            touchdowns
          }
          rushing {
            name
            position
            carries
            yards
            touchdowns
          }
          receiving {
            name
            position
            receptions
            targets
            yards
            touchdowns
          }
        }
      }
    }
  }
`);
